import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Container } from 'react-bootstrap';
import LoadThongTinService from '../../services/LoadThongTinService';
import DriverService from '../../services/DriverService';
import Select from 'react-select';

function InputForm() {
  const [bienKiemSoatOptions, setBienKiemSoatOptions] = useState([]);
  const [buuCucOptions, setBuuCucOptions] = useState([]); // Danh sách cho Điểm đi, Điểm đến, Đơn vị sử dụng
  const [maChuyenList, setMaChuyenList] = useState([]);

  const [formData, setFormData] = useState({
    bien_kiem_soat: '',
    ma_chuyen: '',
    ngay_khoi_hanh: '',
    gio_di_gio: [],
    gio_di_phut: [],
    gio_den_gio: [],
    gio_den_phut: [],
    diem_di: [],
    loai_chay: [],
    diem_den: [],
    km_dau: [],
    km_cuoi: [],
    so_kien_tai: [],
    len_xe: [],
    xuong_xe: [],
    ma_buu_cuc: [],
    ghi_chu: [],
    loai_chi_phi: [],
    chi_phi: [],
    ghi_chu_chi_phi: [],
    anh_minh_chung: [] // Thêm thuộc tính để lưu hình ảnh được upload
  });

  const [showChiPhi, setShowChiPhi] = useState(false); // Trạng thái hiển thị chi phí

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Cập nhật formData ngay khi người dùng nhập liệu
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === 'ma_chuyen' && value !== '') {
      // Chuyển đổi giá trị sang chữ hoa để so sánh không phân biệt hoa/thường
      const normalizedValue = value.toUpperCase();

      if (maChuyenList.some((item) => item.includes(normalizedValue))) {
        updatedValue = '';
        alert('Mã chuyến đã tồn tại!');
      } else {
        // Chuyển đổi dấu '-' hoặc '.' thành '_'
        updatedValue = updatedValue.replace(/[-.]/g, '_');

        // Loại bỏ dấu cách thừa ở đầu và cuối, và các khoảng trắng dư thừa bên trong
        updatedValue = updatedValue.trim().replace(/\s+/g, ' ');

        // Chuyển đổi giá trị sang chữ hoa
        updatedValue = updatedValue.toUpperCase();

        // Kiểm tra xem mã chuyến có chứa "CX" không
        if (!updatedValue.includes("CX")) {
          alert("Mã chuyến xe phải có CX");
          updatedValue = "CX" + updatedValue;
        }
      }
    }

    // Cập nhật formData
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: updatedValue
    }));
  };

  const handleChangeBKS = (selectedOption, { name }) => {
    const value = selectedOption ? selectedOption.value : '';

    setFormData({
      ...formData,
      [name]: value // Sử dụng name truyền vào từ hàm onChange
    });
  };

  const handleArrayChange = (index, eventOrValue, fieldName) => {
    let value;

    if (typeof eventOrValue === 'object' && eventOrValue.target) {
      // Đây là một sự kiện của Form.Control
      value = eventOrValue.target.value;
      fieldName = eventOrValue.target.name;
    } else {
      // Đây là giá trị trực tiếp từ Typeahead
      value = eventOrValue;
    }

    // Kiểm tra nếu fieldName là một mảng trong formData, sau đó cập nhật mảng
    if (Array.isArray(formData[fieldName])) {
      const updatedArray = [...formData[fieldName]];
      updatedArray[index] = value;
      setFormData({
        ...formData,
        [fieldName]: updatedArray,
      });
    } else {
      console.error(`${fieldName} is not an array or undefined`);
    }
  };

  const addField = (fieldName) => {
    if (fieldName === 'gio_di_gio') {
      ['gio_di_gio', 'gio_di_phut', 'gio_den_gio', 'gio_den_phut', 'km_dau', 'km_cuoi', 'so_kien_tai', 'len_xe', 'xuong_xe'].forEach((newFieldName) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [newFieldName]: [...prevFormData[newFieldName], '0']
        }));
      });
      ['diem_di', 'diem_den', 'ma_buu_cuc', 'ghi_chu'].forEach((newFieldName) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [newFieldName]: [...prevFormData[newFieldName], '']
        }));
      });
      setFormData((prevFormData) => ({
        ...prevFormData,
        loai_chay: [...prevFormData['loai_chay'], 'Kết nối']
      }));
    }
    if (fieldName === 'loai_chi_phi') {
      setShowChiPhi(true); // Hiển thị phần chi phí nếu thêm chi phí
      setFormData((prevFormData) => ({
        ...prevFormData,
        loai_chi_phi: [...prevFormData['loai_chi_phi'], ''], // Thêm một loại chi phí trống
        chi_phi: [...prevFormData['chi_phi'], ''],           // Thêm một chi phí trống
        anh_minh_chung: [...prevFormData['anh_minh_chung'], null], // Thêm ảnh minh chứng trống
        ghi_chu_chi_phi: [...prevFormData['ghi_chu_chi_phi'], ''] // Thêm ghi chú trống
      }));
    }
  };

  const removeField = (fieldName, index) => {
    if (fieldName === 'gio_di_gio') {
      // Xóa dữ liệu tại index tương ứng cho tất cả các trường liên quan trong nhóm gio_di_gio
      setFormData((prevFormData) => ({
        ...prevFormData,
        gio_di_gio: prevFormData.gio_di_gio.filter((_, i) => i !== index),
        gio_di_phut: prevFormData.gio_di_phut.filter((_, i) => i !== index),
        gio_den_gio: prevFormData.gio_den_gio.filter((_, i) => i !== index),
        gio_den_phut: prevFormData.gio_den_phut.filter((_, i) => i !== index),
        diem_di: prevFormData.diem_di.filter((_, i) => i !== index),
        loai_chay: prevFormData.loai_chay.filter((_, i) => i !== index),
        diem_den: prevFormData.diem_den.filter((_, i) => i !== index),
        km_dau: prevFormData.km_dau.filter((_, i) => i !== index),
        km_cuoi: prevFormData.km_cuoi.filter((_, i) => i !== index),
        so_kien_tai: prevFormData.so_kien_tai.filter((_, i) => i !== index),
        len_xe: prevFormData.len_xe.filter((_, i) => i !== index),
        xuong_xe: prevFormData.xuong_xe.filter((_, i) => i !== index),
        ma_buu_cuc: prevFormData.ma_buu_cuc.filter((_, i) => i !== index),
        ghi_chu: prevFormData.ghi_chu.filter((_, i) => i !== index),
      }));
    } else if (fieldName === 'loai_chi_phi') {
      // Xóa dữ liệu tại index tương ứng cho tất cả các trường liên quan trong nhóm loai_chi_phi
      setFormData((prevFormData) => ({
        ...prevFormData,
        loai_chi_phi: prevFormData.loai_chi_phi.filter((_, i) => i !== index),
        chi_phi: prevFormData.chi_phi.filter((_, i) => i !== index),
        ghi_chu_chi_phi: prevFormData.ghi_chu_chi_phi.filter((_, i) => i !== index),
        anh_minh_chung: prevFormData.anh_minh_chung.filter((_, i) => i !== index),
      }));

      if (formData.loai_chi_phi.length === 1) {
        setShowChiPhi(false); // Ẩn phần chi phí nếu không còn chi phí nào
      }
    }
  };

  useEffect(() => {
    // Lấy danh sách biển kiểm soát từ API khi component mount
    const fetchBienKiemSoat = async () => {
      try {
        const response = await LoadThongTinService.getBienKiemSoat();
        setBienKiemSoatOptions(response.data);
      } catch (error) {
        console.error("Error fetching biển kiểm soát:", error);
      }
    };

    // Lấy danh sách điểm đi, điểm đến, đơn vị sử dụng từ API khi component mount
    const fetchMaBuuCuc = async () => {
      try {
        const response = await LoadThongTinService.getMaBuuCuc();
        setBuuCucOptions(response.data); // Gán danh sách từ API
      } catch (error) {
        console.error("Error fetching ma buu cuc:", error);
      }
    };

    // Lấy danh sách điểm đi, điểm đến, đơn vị sử dụng từ API khi component mount
    const fetchMaChuyen = async () => {
      try {
        const response = await LoadThongTinService.getMaChuyen();
        setMaChuyenList(response); // Gán danh sách từ API
      } catch (error) {
        console.error("Error fetching ma chuyen:", error);
      }
    };

    fetchBienKiemSoat();
    fetchMaBuuCuc();
    fetchMaChuyen();
  }, []);

  const handleImageUpload = (e, index) => {
    const file = e.target.files[0];
  
    if (file) {
      const reader = new FileReader();
  
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
  
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
  
          // Giả sử bạn muốn kích thước tối đa là 800x800
          const maxWidth = 800;
          const maxHeight = 800;
  
          let width = img.width;
          let height = img.height;
  
          // Tính toán lại kích thước để giữ tỷ lệ
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
  
          // Cập nhật lại kích thước của canvas
          canvas.width = width;
          canvas.height = height;
  
          // Vẽ ảnh lên canvas với kích thước mới
          ctx.drawImage(img, 0, 0, width, height);
  
          // Chuyển canvas thành Blob ở định dạng JPG và cập nhật state
          canvas.toBlob((blob) => {
            // Chuyển Blob thành file JPG mới
            const updatedImages = [...formData.anh_minh_chung];
            const newFileName = file.name.replace(/\.[^/.]+$/, "") + ".jpg"; // Đổi đuôi file thành .jpg
            
            updatedImages[index] = new File([blob], newFileName, { type: 'image/jpeg' }); // Tạo file JPG mới
  
            setFormData({
              ...formData,
              anh_minh_chung: updatedImages
            });
          }, 'image/jpeg', 0.8); // Đặt loại MIME là image/jpeg và chất lượng ảnh
        };
      };
  
      reader.readAsDataURL(file); // Đọc file dưới dạng URL để xử lý với Image
    }
  };  

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Kiểm tra nếu các trường bắt buộc rỗng
    if (formData.bien_kiem_soat === '' || formData.ngay_khoi_hanh === '') {
      alert("Không được để trống 'Biển kiểm soát' hoặc 'Ngày khởi hành'.");
      return;
    }

    // Danh sách các trường cần có số lượng phần tử bằng nhau
    const fields1 = [
      'gio_di_gio', 'gio_di_phut', 'gio_den_gio', 'gio_den_phut',
      'diem_di', 'loai_chay', 'diem_den', 'km_dau', 'km_cuoi',
      'so_kien_tai', 'len_xe', 'xuong_xe', 'ma_buu_cuc', 'ghi_chu'
    ];

    const fields2 = ['loai_chi_phi', 'chi_phi', 'ghi_chu_chi_phi', 'anh_minh_chung'];

    // Loại bỏ 'ghi_chu' khỏi fields1 trước khi kiểm tra hasEmptyField
    const fields1WithoutGhiChu = fields1.filter(field => field !== 'ghi_chu');

    // Kiểm tra xem các mảng trong nhóm 1 có cùng số lượng phần tử hay không
    const isFields1Equal = fields1.every(
      field => formData[field].length === formData[fields1[0]].length
    );

    // Kiểm tra xem các mảng trong nhóm 2 có cùng số lượng phần tử hay không
    const isFields2Equal = fields2.every(
      field => formData[field].length === formData[fields2[0]].length
    );

    // Kiểm tra nếu tất cả các trường không được phép có giá trị rỗng ('') ngoại trừ 'ghi_chu'
    const hasEmptyField = fields1WithoutGhiChu.some(field =>
      formData[field].some(value => value === '')
    );

    // Duyệt qua km đầu/cuối
    for (let i = 0; i < formData.km_dau.length; i++) {
      if (formData.km_dau[i] > formData.km_cuoi[i]) {
        alert("Km đầu không được lớn hơn Km cuối.");
        return;
      }
      if (formData.km_dau[i] < 0  || formData.km_cuoi[i] < 0) {
        alert("Km phải lớn hơn 0.");
        return;
      }
    }
    // Duyệt qua trọng lượng lên/xuống
    for (let i = 0; i < formData.len_xe.length; i++) {
      if (formData.len_xe[i] < formData.xuong_xe[i]) {
        alert("Trọng lượng xuống xe không được lớn hơn trọng lượng lên xe.");
        return;
      }
      if (formData.len_xe[i] < 0 || formData.xuong_xe[i] < 0) {
        alert("Trọng lượng phải lớn hơn 0.");
        return;
      }
    }
    // Duyệt qua các phần tử trong mảng loai_chi_phi
    for (let i = 0; i < formData.loai_chi_phi.length; i++) {
      const loaiChiPhi = formData.loai_chi_phi[i];
      const anhMinhChung = formData.anh_minh_chung[i];
      const ghiChuChiPhi = formData.ghi_chu_chi_phi[i];

      // Kiểm tra cho 'Cầu đường' hoặc 'Vá xe'
      if ((loaiChiPhi === 'Cầu đường' || loaiChiPhi === 'Vá xe') && anhMinhChung === '') {
        alert('Đối với loại chi phí là Cầu đường hoặc Vá xe thì phải có ảnh minh chứng.');
        return;
      }

      // Kiểm tra cho 'Khác (Giải trình vào ghi chú)'
      if (loaiChiPhi === 'Khác (Giải trình vào ghi chú)' && ghiChuChiPhi === '') {
        alert('Đối với loại chi phí là Khác thì phải có giải trình vào ghi chú.');
        return;
      }
    }

    // Thông báo nếu có lỗi
    if (!isFields1Equal) {
      alert("Các trường trong thông tin điểm không hợp lệ. Vui lòng kiểm tra lại.");
      return;
    } else if (hasEmptyField) {
      alert("Có trường trong thông tin điểm chưa được điền thông tin. Vui lòng kiểm tra lại.");
      return;
    }

    if (!isFields2Equal) {
      alert("Các trường trong nhóm chi phí không hợp lệ. Vui lòng kiểm tra lại.");
      return;
    }

    // Nếu 'ma_chuyen' rỗng, yêu cầu người dùng xác nhận
    if (formData.ma_chuyen === '') {
      const userConfirmed = window.confirm("Bạn xác nhận chuyến xe này không có mã chuyến đúng không?");
      if (!userConfirmed) {
        return;  // Nếu người dùng nhấn Cancel, dừng lại
      }
    }

    // Chuẩn bị dữ liệu dạng FormData
    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => {
          if (v instanceof File) {
            // Nếu là file, thêm với đúng đối tượng `File`
            formDataToSend.append(key, v, v.name);
          } else {
            formDataToSend.append(key, v);
          }
        });
      } else {
        formDataToSend.append(key, value);
      }
    });

    // Kiểm tra nội dung FormData
    for (let [key, value] of formDataToSend.entries()) {
      console.log(`${key}: ${value}`);
    }

    try {
      const response = await DriverService.submitNhapThongTin(formDataToSend);
      alert('Dữ liệu đã được lưu thành công!');
      console.log(response); // Kiểm tra phản hồi từ server
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <Container fluid id="container_nhap_tt_tai_xe">
      {/* Header */}
      <header className="mb-4 text-center">
        <h1>Nhập Liệu Chuyến Xe</h1>
        <p>Vui lòng nhập đầy đủ thông tin cho chuyến xe và các chi phí nếu có.</p>
      </header>

      <Form onSubmit={handleSubmit} id="nhap_thong_tin_tai_xe">
        {/* Các trường nhập liệu chính */}
        <Row>
          <Col>
            <Form.Group controlId="bien_kiem_soat">
              <Form.Label>Biển kiểm soát</Form.Label>
              <Select
                id="bien_kiem_soat"
                name="bien_kiem_soat"
                options={bienKiemSoatOptions.map(option => ({ value: option, label: option }))}
                placeholder="Chọn biển kiểm soát"
                onChange={(selectedOption) => handleChangeBKS(selectedOption, { name: 'bien_kiem_soat' })} // Truyền thêm name
                value={formData.bien_kiem_soat ? { value: formData.bien_kiem_soat, label: formData.bien_kiem_soat } : null} // Xử lý giá trị đã chọn
              />
            </Form.Group>

          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group controlId="ma_chuyen">
              <Form.Label>Mã chuyến</Form.Label>
              <Form.Control
                type="text"
                name="ma_chuyen"
                value={formData.ma_chuyen}
                onChange={handleInputChange}
                onBlur={handleChange}
                placeholder="Tự động tạo nếu để trống"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group controlId="ngay_khoi_hanh">
              <Form.Label>Ngày khởi hành</Form.Label>
              <Form.Control
                type="date"
                name="ngay_khoi_hanh"
                value={formData.ngay_khoi_hanh}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Các trường lặp cho giờ đi, giờ đến, điểm đi, điểm đến, loai chay, km dau, km cuoi */}
        {formData.gio_di_gio.map((_, index) => (
          <div key={index} className="mb-4">
            <h5 style={{ marginTop: '20px' }}>Thông tin điểm {index + 1}</h5>
            <Row>
              <Col>
                <Form.Group controlId={`loai_chay_${index}`}>
                  <Form.Label>Loại chạy</Form.Label>
                  <Form.Select
                    name="loai_chay"
                    value={formData.loai_chay[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                    className="dropdown-limit"  // Áp dụng lớp CSS giới hạn chiều cao
                  >
                    <option value="" disabled></option>
                    <option value="Kết Nối Đi">Kết Nối Đi</option>
                    <option value="Kết Nối Về">Kết Nối Về</option>
                    <option value="Phát Hàng">Phát Hàng</option>
                    <option value="Phục Vụ Thu Điểm Cuối">Phục Vụ Thu Điểm Cuối</option>
                    <option value="Phục Vụ Điểm Cuối (chiều rỗng hàng)">Phục Vụ Điểm Cuối (chiều rỗng hàng)</option>
                    <option value="Phục Vụ Phát Điểm Cuối">Phục Vụ Phát Điểm Cuối</option>
                    <option value="Phục Vụ Thu Giữa HT">Phục Vụ Thu Giữa HT</option>
                    <option value="Phục Vụ Phát Giữa HT">Phục Vụ Phát Giữa HT</option>
                    <option value="Kinh Doanh">Kinh Doanh</option>
                    <option value="Kinh Doanh Có Nhận Chuyến VTMan">Kinh Doanh Có Nhận Chuyến VTMan</option>
                    <option value="Kinh Doanh Không Nhận Chuyến VTMan">Kinh Doanh Không Nhận Chuyến VTMan</option>
                    <option value="Đăng Kiểm">Đăng Kiểm</option>
                    <option value="Sửa Chữa">Sửa Chữa</option>
                    <option value="Di Chuyển Từ Bãi Xe">Di Chuyển Từ Bãi Xe</option>
                    <option value="Khác (Giải trình vào ghi chú)">Khác (Giải trình vào ghi chú)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`gio_di_gio_${index}`}>
                  <Form.Label>Giờ đi (Giờ)</Form.Label>
                  <Form.Select
                    name="gio_di_gio"
                    value={formData.gio_di_gio[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <option key={i} value={i}>
                        {i}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId={`gio_di_phut_${index}`}>
                  <Form.Label>Giờ đi (Phút)</Form.Label>
                  <Form.Select
                    name="gio_di_phut"
                    value={formData.gio_di_phut[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  >
                    {Array.from({ length: 60 }, (_, i) => (
                      <option key={i} value={i}>
                        {i}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`gio_den_gio_${index}`}>
                  <Form.Label>Giờ đến (Giờ)</Form.Label>
                  <Form.Select
                    name="gio_den_gio"
                    value={formData.gio_den_gio[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <option key={i} value={i}>
                        {i}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId={`gio_den_phut_${index}`}>
                  <Form.Label>Giờ đến (Phút)</Form.Label>
                  <Form.Select
                    name="gio_den_phut"
                    value={formData.gio_den_phut[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  >
                    {Array.from({ length: 60 }, (_, i) => (
                      <option key={i} value={i}>
                        {i}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`diem_di_${index}`}>
                  <Form.Label>Điểm đi</Form.Label>
                  <Select
                    id={`diem_di_${index}`}
                    options={buuCucOptions.map(option => ({ value: option, label: option }))}
                    placeholder="Chọn điểm đi"
                    onChange={(selected) => handleArrayChange(index, selected ? selected.value : '', 'diem_di')}
                    value={formData.diem_di[index] ? { value: formData.diem_di[index], label: formData.diem_di[index] } : null}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`diem_den_${index}`}>
                  <Form.Label>Điểm đến</Form.Label>
                  <Select
                    id={`diem_den_${index}`}
                    options={buuCucOptions.map(option => ({ value: option, label: option }))}
                    placeholder="Chọn điểm đến"
                    onChange={(selected) => handleArrayChange(index, selected ? selected.value : '', 'diem_den')}
                    value={formData.diem_den[index] ? { value: formData.diem_den[index], label: formData.diem_den[index] } : null}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`km_dau_${index}`}>
                  <Form.Label>Km đầu</Form.Label>
                  <Form.Control
                    type="number"
                    name="km_dau"
                    value={formData.km_dau[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId={`km_cuoi_${index}`}>
                  <Form.Label>Km cuối</Form.Label>
                  <Form.Control
                    type="number"
                    name="km_cuoi"
                    value={formData.km_cuoi[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`tong_km_${index}`}>
                  <Form.Label>Tổng Km</Form.Label>
                  <Form.Control
                    type="number"
                    name="tong_km"
                    value={isNaN(formData.km_dau[index]) || isNaN(formData.km_cuoi[index]) ? '0' : formData.km_cuoi[index] - formData.km_dau[index]}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId={`so_kien_tai_${index}`}>
                  <Form.Label>Số kiện/tải</Form.Label>
                  <Form.Control
                    type="number"
                    name="so_kien_tai"
                    value={formData.so_kien_tai[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`len_xe_${index}`}>
                  <Form.Label>Trọng lượng lên (kg)</Form.Label>
                  <Form.Control
                    type="number"
                    name="len_xe"
                    value={formData.len_xe[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId={`xuong_xe_${index}`}>
                  <Form.Label>Trọng lượng xuống (kg)</Form.Label>
                  <Form.Control
                    type="number"
                    name="xuong_xe"
                    value={formData.xuong_xe[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`ma_buu_cuc_${index}`}>
                  <Form.Label>Đơn vị sử dụng</Form.Label>
                  <Select
                    id={`ma_buu_cuc_${index}`}
                    options={buuCucOptions.map(option => ({ value: option, label: option }))}
                    placeholder="Chọn đơn vị sử dụng"
                    onChange={(selected) => handleArrayChange(index, selected ? selected.value : '', 'ma_buu_cuc')}
                    value={formData.ma_buu_cuc[index] ? { value: formData.ma_buu_cuc[index], label: formData.ma_buu_cuc[index] } : null}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId={`ghi_chu_${index}`}>
                  <Form.Label>Ghi chú</Form.Label>
                  <Form.Control
                    type="text"
                    name="ghi_chu"
                    value={formData.ghi_chu[index]}
                    onChange={(e) => handleArrayChange(index, e)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Button className='xoa' variant="dark" onClick={() => removeField('gio_di_gio', index)}>
              Xóa điểm
            </Button>
          </div>
        ))}

        <Button variant="success" onClick={() => addField('gio_di_gio')}>Thêm điểm</Button>

        {/* Hiển thị nút thêm chi phí */}
        <div className="mt-4">
          <Button variant="success" onClick={() => addField('loai_chi_phi')}>
            Thêm chi phí
          </Button>
        </div>

        {/* Phần nhập chi phí chỉ hiển thị khi người dùng chọn "Thêm chi phí" */}
        {showChiPhi && (
          <div className="mt-4">
            <h3>Chi phí</h3>
            {formData.loai_chi_phi.map((_, index) => (
              <div key={index}>
                <Row>
                  <Col>
                    <Form.Group controlId={`loai_chi_phi_${index}`}>
                      <Form.Label>Loại chi phí</Form.Label>
                      <Form.Select
                        name="loai_chi_phi"
                        value={formData.loai_chi_phi[index]}
                        onChange={(e) => handleArrayChange(index, e)}
                      >
                        <option value="" disabled></option>
                        <option value="Cầu đường">Cầu đường</option>
                        <option value="Vá xe">Vá xe</option>
                        <option value="Khác (Giải trình vào ghi chú)">Khác (Giải trình vào ghi chú)</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId={`chi_phi_${index}`}>
                      <Form.Label>Chi phí</Form.Label>
                      <Form.Control
                        type="number"
                        name="chi_phi"
                        value={formData.chi_phi[index]}
                        onChange={(e) => handleArrayChange(index, e)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {/* Input file chỉ chấp nhận hình ảnh */}
                    <Form.Group controlId={`anh_minh_chung_${index}`}>
                      <Form.Label>Ảnh minh chứng</Form.Label>
                      <Form.Control
                        type="file"
                        name="anh_minh_chung"
                        accept="image/*" // Chỉ chấp nhận file hình ảnh
                        onChange={(e) => handleImageUpload(e, index)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId={`ghi_chu_chi_phi_${index}`}>
                      <Form.Label>Ghi chú chi phí</Form.Label>
                      <Form.Control
                        type="text"
                        name="ghi_chu_chi_phi"
                        value={formData.ghi_chu_chi_phi[index]}
                        onChange={(e) => handleArrayChange(index, e)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Button className='xoa' variant="dark" onClick={() => removeField('loai_chi_phi', index)}>
                  Xóa chi phí
                </Button>
              </div>
            ))}
          </div>
        )}


        <Button variant="danger" type="submit" className="mt-3">
          Gửi dữ liệu
        </Button>
      </Form>
    </Container>
  );
}

export default InputForm;
